import { scaleQuantile } from 'd3-scale';


// 11s from https://observablehq.com/@d3/color-schemes
const continuousColors = {
  'Blues': ["#f7fbff", "#e3eef9", "#cfe1f2", "#b5d4e9", "#93c3df", "#6daed5", "#4b97c9", "#2f7ebc", "#1864aa", "#0a4a90", "#08306b"],
  'Greens': ["#f7fcf5", "#e8f6e3", "#d3eecd", "#b7e2b1", "#97d494", "#73c378", "#4daf62", "#2f984f", "#157f3b", "#036429", "#00441b"],
  'Reds': ["#fff5f0", "#fee3d6", "#fdc9b4", "#fcaa8e", "#fc8a6b", "#f9694c", "#ef4533", "#d92723", "#bb151a", "#970b13", "#67000d"],
  'YlGnBu': ["#ffffd9", "#eff9bd", "#d5eeb3", "#a9ddb7", "#73c9bd", "#45b4c2", "#2897bf", "#2073b2", "#234ea0", "#1c3185", "#081d58"],
  'RdPu': ["#fff7f3", "#fde4e1", "#fccfcc", "#fbb5bc", "#f993b0", "#f369a3", "#e03e98", "#c01788", "#99037c", "#700174", "#49006a"],
  'Magma': ["#000004", "#140e36", "#3b0f70", "#641a80", "#8c2981", "#b73779", "#de4968", "#f7705c", "#fe9f6d", "#fecf92", "#fcfdbf"],
  'Viridis': ["#440154", "#482475", "#414487", "#355f8d", "#2a788e", "#21918c", "#22a884", "#44bf70", "#7ad151", "#bddf26", "#fde725"],
  'RdYlGn': ["#a50026", "#d73027", "#f46d43", "#fdae61", "#fee08b", "#ffffbf", "#d9ef8b", "#a6d96a", "#66bd63", "#1a9850", "#006837"],
  'RdBu': ["#67001f", "#b2182b", "#d6604d", "#f4a582", "#fddbc7", "#f7f7f7", "#d1e5f0", "#92c5de", "#4393c3", "#2166ac", "#053061"],
  'PRGn': ["#40004b", "#762a83", "#9970ab", "#c2a5cf", "#e7d4e8", "#f7f7f7", "#d9f0d3", "#a6dba0", "#5aae61", "#1b7837", "#00441b"],
}


export const continuousPaint = (propExpression, values) => {

  const range = continuousColors.Viridis;
  const colorFunc = scaleQuantile(values, range)

  const ll = [
    "interpolate",
    ["linear"],
    ["to-number", propExpression],
  ]
  // mapbox requires "strictly ascending order" so remove dupes
  const done = new Set()
  range.forEach(c => {
    const num = colorFunc.invertExtent(c)[1];
    if (done.has(num)) return
    done.add(num)
    ll.push(num)
    ll.push(c)
  })
  return ll;
}
